import { createChildActions } from 'helpers/actions'
import entityNames from 'options/entityNames'

const entityName = entityNames.locationCounts
const childName = 'locationCountDetails'

export default {
  ...createChildActions(entityName, childName),
}
